import { useThroughputTabStore } from '../../../../../store/strategy-store/strategy-store';
import {
  setPerformanceActivePanel,
  showEpicRelatedTasks,
  showInitiativeRelatedTasks,
  showOutcomeRelatedTasks,
  showTeamRelatedTasks,
} from '../../../../../store/strategy-store/strategy-store.actions';
import { SideSectionEpics } from '../../components/side-section-epics/side-section-epics';
import { SideSectionInitiatives } from '../../components/side-section-initiatives/side-section-initiatives';
import { SideSectionOutcomes } from '../../components/side-section-outcomes/side-section-outcomes';
import { SideSectionTeams } from '../../components/side-section-teams/side-section-teams';
import { ThroughputMode } from '../../initiative-performance.type';

export const SideSection = () => {
  const throughputMode = useThroughputTabStore((state) => state.mode);

  const team = useThroughputTabStore((state) => state.selectedTeam);
  const epic = useThroughputTabStore((state) => state.selectedEpic);
  const initiative = useThroughputTabStore((state) => state.selectedInitiative);
  const outcome = useThroughputTabStore((state) => state.selectedOutcome);
  const selectedDate = useThroughputTabStore((state) => state.selectedDate);

  const onClose = () => {
    setPerformanceActivePanel(null);
  };

  const onClickEpicRelatedTasks = () => {
    if (!selectedDate) {
      return;
    }

    showEpicRelatedTasks({ epic: epic?.id, date: selectedDate });
  };

  const onClickTeamRelatedTasks = () => {
    if (!selectedDate) {
      return;
    }

    showTeamRelatedTasks({ team: team?.id, date: selectedDate });
  };

  const onClickInitiativeRelatedTasks = () => {
    if (!selectedDate) {
      return;
    }

    showInitiativeRelatedTasks({ initiative: initiative?.id, date: selectedDate });
  };

  const onClickOutcomeRelatedTasks = () => {
    if (!selectedDate) {
      return;
    }

    showOutcomeRelatedTasks({ outcome: outcome?.id, date: selectedDate });
  };

  switch (throughputMode) {
    case ThroughputMode.ContributingEpics:
      return (
        <SideSectionEpics
          epic={epic}
          selectedDate={selectedDate}
          onClose={onClose}
          onClickRelatedTasks={onClickEpicRelatedTasks}
        />
      );
    case ThroughputMode.ContributingTeams:
      return (
        <SideSectionTeams
          team={team}
          selectedDate={selectedDate}
          onClose={onClose}
          onClickRelatedTasks={onClickTeamRelatedTasks}
        />
      );
    case ThroughputMode.ContributingInitiatives:
      return (
        <SideSectionInitiatives
          initiative={initiative}
          selectedDate={selectedDate}
          onClose={onClose}
          onClickRelatedTasks={onClickInitiativeRelatedTasks}
        />
      );
    case ThroughputMode.ContributingOutcomes:
      return (
        <SideSectionOutcomes
          outcome={outcome}
          selectedDate={selectedDate}
          onClose={onClose}
          onClickRelatedTasks={onClickOutcomeRelatedTasks}
        />
      );
    default:
      return null;
  }
};
